export default "assets/domains-map-9bcbdc9e.jpg";